/** Decode only to choose how to restart the UI; the API still verifies every credential. */
const tokenUserId = (token: string): number | null => {
	try {
		const parts = token.split(".");

		if (parts.length !== 3 || !parts[0] || !parts[2] || !/^[\w-]+$/.test(parts[1])) {
			return null;
		}

		const payload: unknown = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));

		// AuthService.login signs the numeric user.id as `id`, not `sub` or `userId`.
		if (payload && typeof payload === "object" && "id" in payload) {
			const id = payload.id;

			return typeof id === "number" && Number.isSafeInteger(id) && id > 0 ? id : null;
		}
	} catch {
		return null;
	}

	return null;
};

export const tokenAdoptionDecision = (
	rejectedToken: string | null | undefined,
	storedToken: string | null
): "adopt" | "reload" | "logout" => {
	if (!rejectedToken || !storedToken || rejectedToken === storedToken) {
		return "logout";
	}

	const rejectedUserId = tokenUserId(rejectedToken);
	const storedUserId = tokenUserId(storedToken);

	return rejectedUserId !== null && rejectedUserId === storedUserId ? "adopt" : "reload";
};
